import { render, staticRenderFns } from "./dropdown_button.vue?vue&type=template&id=79b4c176&"
import script from "./dropdown_button.vue?vue&type=script&lang=js&"
export * from "./dropdown_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports